<template>
  <div style="width: 100%">
    <vxe-table border auto-resize resizable show-overflow keep-source :data="tableData">
      <vxe-table-column type="seq" title="序号" width="60" align="center"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) of tableColumn"
        :key="index"
        :field="item.field"
        :title="item.title"
        :edit-render="item.itemRender"
        :minWidth="item.width"
      >
        <template v-slot="{ row }">
          <template v-if="item.field === 'versionName'">
            <el-button type="text" @click="goDetailHandler(row)">{{ row[item.field] }}</el-button>
          </template>
          <template v-else>{{ row[item.field] }}</template>
        </template>
      </vxe-table-column>
    </vxe-table>
    <VersionHistoryDialog ref="versionHistoryDialogRef" />
  </div>
</template>

<script>
  import VersionHistoryDialog from './components/VersionHistoryDialog/index.vue';
  export default {
    name: 'ChangeRecordTable',
    props: {
      fetchTableData: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableColumn: [
          {
            title: '版本名称',
            field: 'versionName',
          },
          {
            title: '变更日期',
            field: 'changeDate',
          },
          {
            title: '操作人',
            field: 'operatorName',
          },
        ],
        tableData: [],
      };
    },
    methods: {
      goDetailHandler(rowData) {
        this.$refs.versionHistoryDialogRef.openDialog(rowData.changeContent);
      },
    },
    watch: {
      fetchTableData: {
        handler(val) {
          if (val && val.length) {
            this.tableData = val;
          }
        },
        immediate: true,
      },
    },
    components: {
      VersionHistoryDialog,
    },
  };
</script>

<style lang="scss" scoped></style>
